// Generated from vendor/cdialer/src/cdialer/countries.py (COUNTRY_TABLE).
// Do not edit by hand: pytest tests/test_country_table.py pins this file.
import type { DialCountry } from "./country";

export const ISO_COUNTRIES: readonly DialCountry[] = [
  { iso2: "AD", name: "Andorra", calling_code: "376" },
  { iso2: "AE", name: "United Arab Emirates", calling_code: "971" },
  { iso2: "AF", name: "Afghanistan", calling_code: "93" },
  { iso2: "AG", name: "Antigua and Barbuda", calling_code: "1" },
  { iso2: "AI", name: "Anguilla", calling_code: "1" },
  { iso2: "AL", name: "Albania", calling_code: "355" },
  { iso2: "AM", name: "Armenia", calling_code: "374" },
  { iso2: "AO", name: "Angola", calling_code: "244" },
  { iso2: "AR", name: "Argentina", calling_code: "54" },
  { iso2: "AS", name: "American Samoa", calling_code: "1" },
  { iso2: "AT", name: "Austria", calling_code: "43" },
  { iso2: "AU", name: "Australia", calling_code: "61" },
  { iso2: "AW", name: "Aruba", calling_code: "297" },
  { iso2: "AX", name: "Aland Islands", calling_code: "358" },
  { iso2: "AZ", name: "Azerbaijan", calling_code: "994" },
  { iso2: "BA", name: "Bosnia and Herzegovina", calling_code: "387" },
  { iso2: "BB", name: "Barbados", calling_code: "1" },
  { iso2: "BD", name: "Bangladesh", calling_code: "880" },
  { iso2: "BE", name: "Belgium", calling_code: "32" },
  { iso2: "BF", name: "Burkina Faso", calling_code: "226" },
  { iso2: "BG", name: "Bulgaria", calling_code: "359" },
  { iso2: "BH", name: "Bahrain", calling_code: "973" },
  { iso2: "BI", name: "Burundi", calling_code: "257" },
  { iso2: "BJ", name: "Benin", calling_code: "229" },
  { iso2: "BL", name: "Saint Barthelemy", calling_code: "590" },
  { iso2: "BM", name: "Bermuda", calling_code: "1" },
  { iso2: "BN", name: "Brunei", calling_code: "673" },
  { iso2: "BO", name: "Bolivia", calling_code: "591" },
  { iso2: "BQ", name: "Bonaire, Sint Eustatius and Saba", calling_code: "599" },
  { iso2: "BR", name: "Brazil", calling_code: "55" },
  { iso2: "BS", name: "Bahamas", calling_code: "1" },
  { iso2: "BT", name: "Bhutan", calling_code: "975" },
  { iso2: "BW", name: "Botswana", calling_code: "267" },
  { iso2: "BY", name: "Belarus", calling_code: "375" },
  { iso2: "BZ", name: "Belize", calling_code: "501" },
  { iso2: "CA", name: "Canada", calling_code: "1" },
  { iso2: "CC", name: "Cocos (Keeling) Islands", calling_code: "61" },
  { iso2: "CD", name: "DR Congo", calling_code: "243" },
  { iso2: "CF", name: "Central African Republic", calling_code: "236" },
  { iso2: "CG", name: "Congo", calling_code: "242" },
  { iso2: "CH", name: "Switzerland", calling_code: "41" },
  { iso2: "CI", name: "Cote d'Ivoire", calling_code: "225" },
  { iso2: "CK", name: "Cook Islands", calling_code: "682" },
  { iso2: "CL", name: "Chile", calling_code: "56" },
  { iso2: "CM", name: "Cameroon", calling_code: "237" },
  { iso2: "CN", name: "China", calling_code: "86" },
  { iso2: "CO", name: "Colombia", calling_code: "57" },
  { iso2: "CR", name: "Costa Rica", calling_code: "506" },
  { iso2: "CU", name: "Cuba", calling_code: "53" },
  { iso2: "CV", name: "Cabo Verde", calling_code: "238" },
  { iso2: "CW", name: "Curaçao", calling_code: "599" },
  { iso2: "CX", name: "Christmas Island", calling_code: "61" },
  { iso2: "CY", name: "Cyprus", calling_code: "357" },
  { iso2: "CZ", name: "Czechia", calling_code: "420" },
  { iso2: "DE", name: "Germany", calling_code: "49" },
  { iso2: "DJ", name: "Djibouti", calling_code: "253" },
  { iso2: "DK", name: "Denmark", calling_code: "45" },
  { iso2: "DM", name: "Dominica", calling_code: "1" },
  { iso2: "DO", name: "Dominican Republic", calling_code: "1" },
  { iso2: "DZ", name: "Algeria", calling_code: "213" },
  { iso2: "EC", name: "Ecuador", calling_code: "593" },
  { iso2: "EE", name: "Estonia", calling_code: "372" },
  { iso2: "EG", name: "Egypt", calling_code: "20" },
  { iso2: "EH", name: "Western Sahara", calling_code: "212" },
  { iso2: "ER", name: "Eritrea", calling_code: "291" },
  { iso2: "ES", name: "Spain", calling_code: "34" },
  { iso2: "ET", name: "Ethiopia", calling_code: "251" },
  { iso2: "FI", name: "Finland", calling_code: "358" },
  { iso2: "FJ", name: "Fiji", calling_code: "679" },
  { iso2: "FK", name: "Falkland Islands", calling_code: "500" },
  { iso2: "FM", name: "Micronesia", calling_code: "691" },
  { iso2: "FO", name: "Faroe Islands", calling_code: "298" },
  { iso2: "FR", name: "France", calling_code: "33" },
  { iso2: "GA", name: "Gabon", calling_code: "241" },
  { iso2: "GB", name: "United Kingdom", calling_code: "44" },
  { iso2: "GD", name: "Grenada", calling_code: "1" },
  { iso2: "GE", name: "Georgia", calling_code: "995" },
  { iso2: "GF", name: "French Guiana", calling_code: "594" },
  { iso2: "GG", name: "Guernsey", calling_code: "44" },
  { iso2: "GH", name: "Ghana", calling_code: "233" },
  { iso2: "GI", name: "Gibraltar", calling_code: "350" },
  { iso2: "GL", name: "Greenland", calling_code: "299" },
  { iso2: "GM", name: "Gambia", calling_code: "220" },
  { iso2: "GN", name: "Guinea", calling_code: "224" },
  { iso2: "GP", name: "Guadeloupe", calling_code: "590" },
  { iso2: "GQ", name: "Equatorial Guinea", calling_code: "240" },
  { iso2: "GR", name: "Greece", calling_code: "30" },
  { iso2: "GS", name: "South Georgia and the South Sandwich Islands", calling_code: "500" },
  { iso2: "GT", name: "Guatemala", calling_code: "502" },
  { iso2: "GU", name: "Guam", calling_code: "1" },
  { iso2: "GW", name: "Guinea-Bissau", calling_code: "245" },
  { iso2: "GY", name: "Guyana", calling_code: "592" },
  { iso2: "HK", name: "Hong Kong", calling_code: "852" },
  { iso2: "HN", name: "Honduras", calling_code: "504" },
  { iso2: "HR", name: "Croatia", calling_code: "385" },
  { iso2: "HT", name: "Haiti", calling_code: "509" },
  { iso2: "HU", name: "Hungary", calling_code: "36" },
  { iso2: "ID", name: "Indonesia", calling_code: "62" },
  { iso2: "IE", name: "Ireland", calling_code: "353" },
  { iso2: "IL", name: "Israel", calling_code: "972" },
  { iso2: "IM", name: "Isle of Man", calling_code: "44" },
  { iso2: "IN", name: "India", calling_code: "91" },
  { iso2: "IO", name: "British Indian Ocean Territory", calling_code: "246" },
  { iso2: "IQ", name: "Iraq", calling_code: "964" },
  { iso2: "IR", name: "Iran", calling_code: "98" },
  { iso2: "IS", name: "Iceland", calling_code: "354" },
  { iso2: "IT", name: "Italy", calling_code: "39" },
  { iso2: "JE", name: "Jersey", calling_code: "44" },
  { iso2: "JM", name: "Jamaica", calling_code: "1" },
  { iso2: "JO", name: "Jordan", calling_code: "962" },
  { iso2: "JP", name: "Japan", calling_code: "81" },
  { iso2: "KE", name: "Kenya", calling_code: "254" },
  { iso2: "KG", name: "Kyrgyzstan", calling_code: "996" },
  { iso2: "KH", name: "Cambodia", calling_code: "855" },
  { iso2: "KI", name: "Kiribati", calling_code: "686" },
  { iso2: "KM", name: "Comoros", calling_code: "269" },
  { iso2: "KN", name: "Saint Kitts and Nevis", calling_code: "1" },
  { iso2: "KP", name: "North Korea", calling_code: "850" },
  { iso2: "KR", name: "South Korea", calling_code: "82" },
  { iso2: "KW", name: "Kuwait", calling_code: "965" },
  { iso2: "KY", name: "Cayman Islands", calling_code: "1" },
  { iso2: "KZ", name: "Kazakhstan", calling_code: "7" },
  { iso2: "LA", name: "Laos", calling_code: "856" },
  { iso2: "LB", name: "Lebanon", calling_code: "961" },
  { iso2: "LC", name: "Saint Lucia", calling_code: "1" },
  { iso2: "LI", name: "Liechtenstein", calling_code: "423" },
  { iso2: "LK", name: "Sri Lanka", calling_code: "94" },
  { iso2: "LR", name: "Liberia", calling_code: "231" },
  { iso2: "LS", name: "Lesotho", calling_code: "266" },
  { iso2: "LT", name: "Lithuania", calling_code: "370" },
  { iso2: "LU", name: "Luxembourg", calling_code: "352" },
  { iso2: "LV", name: "Latvia", calling_code: "371" },
  { iso2: "LY", name: "Libya", calling_code: "218" },
  { iso2: "MA", name: "Morocco", calling_code: "212" },
  { iso2: "MC", name: "Monaco", calling_code: "377" },
  { iso2: "MD", name: "Moldova", calling_code: "373" },
  { iso2: "ME", name: "Montenegro", calling_code: "382" },
  { iso2: "MF", name: "Saint Martin (French part)", calling_code: "590" },
  { iso2: "MG", name: "Madagascar", calling_code: "261" },
  { iso2: "MH", name: "Marshall Islands", calling_code: "692" },
  { iso2: "MK", name: "North Macedonia", calling_code: "389" },
  { iso2: "ML", name: "Mali", calling_code: "223" },
  { iso2: "MM", name: "Myanmar", calling_code: "95" },
  { iso2: "MN", name: "Mongolia", calling_code: "976" },
  { iso2: "MO", name: "Macao", calling_code: "853" },
  { iso2: "MP", name: "Northern Mariana Islands", calling_code: "1" },
  { iso2: "MQ", name: "Martinique", calling_code: "596" },
  { iso2: "MR", name: "Mauritania", calling_code: "222" },
  { iso2: "MS", name: "Montserrat", calling_code: "1" },
  { iso2: "MT", name: "Malta", calling_code: "356" },
  { iso2: "MU", name: "Mauritius", calling_code: "230" },
  { iso2: "MV", name: "Maldives", calling_code: "960" },
  { iso2: "MW", name: "Malawi", calling_code: "265" },
  { iso2: "MX", name: "Mexico", calling_code: "52" },
  { iso2: "MY", name: "Malaysia", calling_code: "60" },
  { iso2: "MZ", name: "Mozambique", calling_code: "258" },
  { iso2: "NA", name: "Namibia", calling_code: "264" },
  { iso2: "NC", name: "New Caledonia", calling_code: "687" },
  { iso2: "NE", name: "Niger", calling_code: "227" },
  { iso2: "NF", name: "Norfolk Island", calling_code: "672" },
  { iso2: "NG", name: "Nigeria", calling_code: "234" },
  { iso2: "NI", name: "Nicaragua", calling_code: "505" },
  { iso2: "NL", name: "Netherlands", calling_code: "31" },
  { iso2: "NO", name: "Norway", calling_code: "47" },
  { iso2: "NP", name: "Nepal", calling_code: "977" },
  { iso2: "NR", name: "Nauru", calling_code: "674" },
  { iso2: "NU", name: "Niue", calling_code: "683" },
  { iso2: "NZ", name: "New Zealand", calling_code: "64" },
  { iso2: "OM", name: "Oman", calling_code: "968" },
  { iso2: "PA", name: "Panama", calling_code: "507" },
  { iso2: "PE", name: "Peru", calling_code: "51" },
  { iso2: "PF", name: "French Polynesia", calling_code: "689" },
  { iso2: "PG", name: "Papua New Guinea", calling_code: "675" },
  { iso2: "PH", name: "Philippines", calling_code: "63" },
  { iso2: "PK", name: "Pakistan", calling_code: "92" },
  { iso2: "PL", name: "Poland", calling_code: "48" },
  { iso2: "PM", name: "Saint Pierre and Miquelon", calling_code: "508" },
  { iso2: "PN", name: "Pitcairn", calling_code: "64" },
  { iso2: "PR", name: "Puerto Rico", calling_code: "1" },
  { iso2: "PS", name: "Palestine", calling_code: "970" },
  { iso2: "PT", name: "Portugal", calling_code: "351" },
  { iso2: "PW", name: "Palau", calling_code: "680" },
  { iso2: "PY", name: "Paraguay", calling_code: "595" },
  { iso2: "QA", name: "Qatar", calling_code: "974" },
  { iso2: "RE", name: "Réunion", calling_code: "262" },
  { iso2: "RO", name: "Romania", calling_code: "40" },
  { iso2: "RS", name: "Serbia", calling_code: "381" },
  { iso2: "RU", name: "Russia", calling_code: "7" },
  { iso2: "RW", name: "Rwanda", calling_code: "250" },
  { iso2: "SA", name: "Saudi Arabia", calling_code: "966" },
  { iso2: "SB", name: "Solomon Islands", calling_code: "677" },
  { iso2: "SC", name: "Seychelles", calling_code: "248" },
  { iso2: "SD", name: "Sudan", calling_code: "249" },
  { iso2: "SE", name: "Sweden", calling_code: "46" },
  { iso2: "SG", name: "Singapore", calling_code: "65" },
  { iso2: "SH", name: "Saint Helena", calling_code: "290" },
  { iso2: "SI", name: "Slovenia", calling_code: "386" },
  { iso2: "SJ", name: "Svalbard and Jan Mayen", calling_code: "47" },
  { iso2: "SK", name: "Slovakia", calling_code: "421" },
  { iso2: "SL", name: "Sierra Leone", calling_code: "232" },
  { iso2: "SM", name: "San Marino", calling_code: "378" },
  { iso2: "SN", name: "Senegal", calling_code: "221" },
  { iso2: "SO", name: "Somalia", calling_code: "252" },
  { iso2: "SR", name: "Suriname", calling_code: "597" },
  { iso2: "SS", name: "South Sudan", calling_code: "211" },
  { iso2: "ST", name: "Sao Tome and Principe", calling_code: "239" },
  { iso2: "SV", name: "El Salvador", calling_code: "503" },
  { iso2: "SX", name: "Sint Maarten (Dutch part)", calling_code: "1" },
  { iso2: "SY", name: "Syria", calling_code: "963" },
  { iso2: "SZ", name: "Eswatini", calling_code: "268" },
  { iso2: "TC", name: "Turks and Caicos Islands", calling_code: "1" },
  { iso2: "TD", name: "Chad", calling_code: "235" },
  { iso2: "TG", name: "Togo", calling_code: "228" },
  { iso2: "TH", name: "Thailand", calling_code: "66" },
  { iso2: "TJ", name: "Tajikistan", calling_code: "992" },
  { iso2: "TK", name: "Tokelau", calling_code: "690" },
  { iso2: "TL", name: "Timor-Leste", calling_code: "670" },
  { iso2: "TM", name: "Turkmenistan", calling_code: "993" },
  { iso2: "TN", name: "Tunisia", calling_code: "216" },
  { iso2: "TO", name: "Tonga", calling_code: "676" },
  { iso2: "TR", name: "Turkey", calling_code: "90" },
  { iso2: "TT", name: "Trinidad and Tobago", calling_code: "1" },
  { iso2: "TV", name: "Tuvalu", calling_code: "688" },
  { iso2: "TW", name: "Taiwan", calling_code: "886" },
  { iso2: "TZ", name: "Tanzania", calling_code: "255" },
  { iso2: "UA", name: "Ukraine", calling_code: "380" },
  { iso2: "UG", name: "Uganda", calling_code: "256" },
  { iso2: "US", name: "United States", calling_code: "1" },
  { iso2: "UY", name: "Uruguay", calling_code: "598" },
  { iso2: "UZ", name: "Uzbekistan", calling_code: "998" },
  { iso2: "VA", name: "Holy See (Vatican City State)", calling_code: "39" },
  { iso2: "VC", name: "Saint Vincent and the Grenadines", calling_code: "1" },
  { iso2: "VE", name: "Venezuela", calling_code: "58" },
  { iso2: "VG", name: "Virgin Islands, British", calling_code: "1" },
  { iso2: "VI", name: "Virgin Islands, U.S.", calling_code: "1" },
  { iso2: "VN", name: "Vietnam", calling_code: "84" },
  { iso2: "VU", name: "Vanuatu", calling_code: "678" },
  { iso2: "WF", name: "Wallis and Futuna", calling_code: "681" },
  { iso2: "WS", name: "Samoa", calling_code: "685" },
  { iso2: "XK", name: "Kosovo", calling_code: "383" },
  { iso2: "YE", name: "Yemen", calling_code: "967" },
  { iso2: "YT", name: "Mayotte", calling_code: "262" },
  { iso2: "ZA", name: "South Africa", calling_code: "27" },
  { iso2: "ZM", name: "Zambia", calling_code: "260" },
  { iso2: "ZW", name: "Zimbabwe", calling_code: "263" },
];
